import { MarketingButtons } from "../../components/MarketingButtons";
import { PageContent } from "../../pages/templates/PageLayout";
import { exampleLinks } from "./exampleLinks";
import featureCards from "../featureCards";
import Images from "../images";

const data: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Digital brand guidelines platform",
      subtitle: `Say goodbye to stale PDF style guides. With Lingo's digital brand guidelines software, anyone can easily create, share, update, and use a modern living digital style guide. [See an example](${exampleLinks.digitalBrandGuidelines}).`,
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      image: {
        src: Images.Solutions.BrandGuidelines.hero,
        alt: "Brand guidelines",
      },
    },
    {
      type: "MediaSection",
      title: "Your brand guidelines in one place",
      subtitle:
        "Logos, colors, fonts, photos, videos, illustrations and more in a single location.",
      layoutDirection: "image-left",
      body: {
        style: "tabList",
        items: [
          {
            title: "Content and Context. Together.",
            body: "Still attaching a stale style guide PDF whenever someone needs to use your logo? With Lingo people can grab the content they need and learn how to use it in the same spot.",
            image: {
              src: Images.Solutions.BrandGuidelines.contentContext,
              alt: "Content and Context. Together.",
            },
          },
          {
            title: "Fully customizable",
            body: "Tell your brand’s unique story by customizing how your assets are categorized and ordered. Better yet, choose a custom font, color, and web link to make your library feel official.",
            image: {
              src: Images.Solutions.BrandGuidelines.customBranding,
              alt: "Fully customizable",
            },
          },
          {
            title: "Private and public sharing",
            body: "Keep your brand guideline private so only people with permission can have access, or make your library public so anyone with the link can have access - no account required.",
            image: {
              src: Images.Solutions.BrandGuidelines.publicSharing,
              alt: "Advanced custom branding",
            },
          },
          {
            title: "Version your style guide",
            body: "Control how changes to your brand guidelines are released to the rest of your team. Roll back to a previous version if needed.",
            image: {
              src: Images.Solutions.BrandGuidelines.versionHistory,
              alt: "Version your style guide",
            },
          },
        ],
      },
    },
    {
      type: "CardSection",
      title: "More features to manage your brand guidelines",
      footerButton: {
        link: "/product/features",
        text: "View all features",
        buttonStyle: "outline",
      },
      items: [
        featureCards.customBranding,
        featureCards.customDomains,
        featureCards.usageGuidelines,
        featureCards.fileConversions,
        featureCards.tags,
        featureCards.kitVersioning,
      ],
    },
    {
      type: "FaqSection",
      title: "Digital Branding Guidelines FAQ",
      faqs: [
        {
          question:
            "How is Lingo different from storing brand guidelines in a PDF or Google Drive?",
          answer:
            "Unlike static PDFs or scattered cloud folders, Lingo's Brand Guidelines are interactive, searchable, and always up to date. They combine content with context, ensuring teams can easily find and use brand-approved assets without confusion or outdated files",
        },
        {
          question: "Can I control who has access to my brand guidelines?",
          answer:
            "Yes! Lingo allows you to set permissions at the user or team level, create public or private kits, and even password-protect certain assets, ensuring only the right people have access to the right content.",
        },
        {
          question: "How does Lingo make it easier for teams to find the right assets?",
          answer:
            "Lingo organizes assets into structured kits with powerful search, metadata tagging, and visual previews, making it easy for anyone to quickly find and use the correct files without disrupting creative workflows.",
        },
        {
          question: "Can external partners, agencies, or vendors access my brand guidelines?",
          answer:
            "Yes! You can securely share brand kits with external teams by providing direct links, setting permissions, or using password protection—ensuring partners always have access to the latest, approved assets.",
        },
      ],
    },
    { type: "CtaSection" },
  ],
};

export default data;
